export function videoPopup() {
    // YouTube / remote embed: copy data-src → src on open
    $(document).on('show.bs.modal', '.sb-video-modal', function () {
        const $iframe = $('.sb-video-iframe', this);
        if ($iframe.length) {
            $iframe.attr('src', $iframe.data('src'));
        }
    });

    // Local <video>: pause + reset on close; remote iframe: clear src
    $(document).on('hide.bs.modal', '.sb-video-modal', function () {
        const $iframe = $('.sb-video-iframe', this);
        if ($iframe.length) {
            $iframe.attr('src', 'about:blank');
        }

        const video = this.querySelector('.sb-video-local');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    });
}